import { Injectable } from "@angular/core";
@Injectable()
export class EFilePaymentDto {
    applicationId: string;
    paymentDate: Date;
    amount: string;
    appliedAmount: string;
    transactionId: string;
    statusId: number;
    username: string;
}
